var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23417 0.277138C1.41185 0.0996771 1.65271 0 1.90383 0C2.15495 0 2.39581 0.0996771 2.57349 0.277138L6.01023 3.71388L9.44698 0.277138C9.62662 0.109748 9.86421 0.01862 10.1097 0.0229516C10.3552 0.0272832 10.5895 0.126736 10.7631 0.300359C10.9367 0.473981 11.0362 0.708217 11.0405 0.953719C11.0448 1.19922 10.9537 1.43682 10.7863 1.61646L6.67989 5.72286C6.50221 5.90032 6.26136 6 6.01023 6C5.75911 6 5.51825 5.90032 5.34057 5.72286L1.23417 1.61646C1.05671 1.43878 0.957031 1.19792 0.957031 0.946798C0.957031 0.695674 1.05671 0.454819 1.23417 0.277138Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevronDown.4a2b389657ec772d3ee03dc5572b1989.svg";
export { ForwardRef as ReactComponent };